/** Next-slot label helpers for Featured cards. */
/** "Tue 3:00 PM" / "Today 3:00 PM" / "Tomorrow 9:00 AM" in the viewer's zone. */
export const formatNextSlotLabel = (ms, nowMs = Date.now()) => {
  if (!ms) return null;
  const at = new Date(ms);
  const now = new Date(nowMs);
  const time = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' }).format(at);
  const dayKey = x => `${x.getFullYear()}-${x.getMonth()}-${x.getDate()}`;
  const tomorrow = new Date(nowMs + 24 * 3600000);
  if (dayKey(at) === dayKey(now)) return `today ${time}`;
  if (dayKey(at) === dayKey(tomorrow)) return `tomorrow ${time}`;
  const day = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(at);
  return `${day} ${time}`;
};
